"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withStyles;

var _utils = require("@mui/utils");

function withStyles() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: withStyles is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : (0, _utils.formatMuiErrorMessage)(15));
}